import { render } from "./NotificationPayment.vue?vue&type=template&id=2e2dcd7c"
import script from "./NotificationPayment.vue?vue&type=script&lang=js"
export * from "./NotificationPayment.vue?vue&type=script&lang=js"
script.render = render

export default script